import { useEffect, useState } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { LoadingScreen } from "Components";
import { UserHover } from "Components/UserHover";
import { newAuthService } from "Service/Axios";
import { APPLICATION_LOGS_URL } from "Constant/api";
import { getFirstLetterOfName } from "Utils";

export const Logs = ({ gid }) => {
  const [loading, setLoading] = useState(false);
  const [allLogs, setAllLogs] = useState([]);

  // Listing
  const getLogsList = async () => {
    const payload = {
      gid,
    };
    setLoading(true);
    const response = await newAuthService(
      APPLICATION_LOGS_URL,
      "POST",
      payload
    );
    if (response.status) {
      setAllLogs(response.data);
      setLoading(false);
    } else {
      setAllLogs([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    getLogsList();
  }, [gid]);

  return (
    <div className="applicant-status-body logs-tab">
      <div className="p-5">
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <LoadingScreen />
          </div>
        ) : (
          Object.keys(allLogs).map((key, i) => (
            <>
              <div className="logs-title">{key}</div>
              <ul className="logs-list">
                {Object.values(allLogs)[i].map((log) => (
                  <li key={log.gid}>
                    <div className="logs-box d-flex flex-wrap">
                      {/* <div className="hover-effect position-relative mb-2">
                      <div className="d-flex align-items-center cursor-pointer">
                        <div className="avatar-img me-2">
                          {log.photoURL ? (
                            <div className="img-box">
                              <img
                                src={log.photoURL}
                                alt={`${log.firstName}${log.lastName}`}
                              />
                            </div>
                          ) : (
                            getFirstLetterOfName(log)
                          )}
                        </div>
                        <h6 className="logs-title mb-0">{log.name}</h6>
                      </div>
                      <UserHover user={log} />
                    </div> */}
                      <OverlayTrigger
                        placement="right"
                        overlay={
                          <Popover className="max-w-unset">
                            <UserHover user={log} />
                          </Popover>
                        }
                      >
                        <div className="d-flex align-items-center mb-2 cursor-pointer">
                          <div className="w-8 h-8 rounded-circle overflow-hidden">
                            {log.photoURL ? (
                              <div className="img-box w-100 h-100">
                                <img
                                  src={log.photoURL}
                                  alt={`${log.firstName} ${log.lastName}`}
                                  className="w-100 h-100 object-fit-cover"
                                />
                              </div>
                            ) : (
                              getFirstLetterOfName(log)
                            )}
                          </div>

                          <div className="avatar-short-dtls ms-2">
                            <h4 className="text-sm font-medium text-slate-600 mb-0 text-nowrap">
                              {log.firstName} {log.lastName}
                            </h4>
                          </div>
                        </div>
                      </OverlayTrigger>
                      <div className="logs-details w-100 ms-5">
                        <div className="logs-text">
                          <p>{log.text}</p>
                        </div>
                      </div>
                      <div className="date-time">{log.time}</div>
                    </div>
                  </li>
                ))}
              </ul>
            </>
          ))
        )}
      </div>
    </div>
  );
};
